import { useNavigate, useSearch } from "@tanstack/react-router";
import { Bell, HelpCircle, Search } from "lucide-react";
import { useEffect, useRef } from "react";
import { MobileSidebar } from "@/components/markyt/MobileSidebar";

export function MarkytTopBar() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false });
  const query = typeof search.q === "string" ? search.q : "";
  const inputRef = useRef<HTMLInputElement>(null);

  function setQuery(q: string) {
    void navigate({ to: "/skills", search: (prev) => ({ ...prev, q: q || undefined }) });
  }

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        void navigate({ to: "/skills" });
        inputRef.current?.focus();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-4 border-b border-border-1 bg-white/[0.88] px-6 backdrop-blur-[12px]">
      <MobileSidebar />
      <div className="flex-1" />
      <div className="relative w-full max-w-[520px]">
        <Search className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-fg-3" />
        <input
          ref={inputRef}
          type="search"
          placeholder="Search skills by name, what they do, or example…"
          aria-label="Search skills"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="h-9 w-full rounded-[9px] border border-border-1 bg-bg-2 pr-12 pl-9 text-sm text-fg-1 outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/40"
        />
        <kbd className="absolute top-1/2 right-3 -translate-y-1/2 rounded border border-border-1 bg-white px-1.5 py-0.5 text-[10px] font-medium text-fg-3">
          ⌘K
        </kbd>
      </div>
      <div className="flex flex-1 items-center justify-end gap-1">
        <button
          type="button"
          aria-label="Notifications"
          className="relative grid size-9 place-items-center rounded-[9px] text-fg-2 hover:bg-bg-3"
        >
          <Bell className="size-5" />
          <span className="absolute top-2 right-2 size-2 rounded-full bg-danger" />
        </button>
        <button
          type="button"
          aria-label="Help"
          className="grid size-9 place-items-center rounded-[9px] text-fg-2 hover:bg-bg-3"
        >
          <HelpCircle className="size-5" />
        </button>
      </div>
    </header>
  );
}
